import { render, staticRenderFns } from "./TemperatureDashboard2.vue?vue&type=template&id=1ee3d2de&scoped=true"
import script from "./TemperatureDashboard2.vue?vue&type=script&lang=js"
export * from "./TemperatureDashboard2.vue?vue&type=script&lang=js"
import style0 from "./TemperatureDashboard2.vue?vue&type=style&index=0&id=1ee3d2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee3d2de",
  null
  
)

export default component.exports